export var EmailType;
(function (EmailType) {
    EmailType["ORDER_ACCEPTED"] = "ORDER_ACCEPTED";
    EmailType["ORDER_DECLINED"] = "ORDER_DECLINED";
    EmailType["ORDER_CHANGED"] = "ORDER_CHANGED";
    EmailType["ORDER_CANCELLED"] = "ORDER_CANCELLED";
})(EmailType || (EmailType = {}));
